import axios from "axios";

// LF360-2024: project roles and the permission catalogue.
const getRoles = () => axios.get("api/v1/roles");

const getRole = (id) => axios.get(`api/v1/roles/${id}`);

const getCatalog = () => axios.get("api/v1/permissions/catalog");

// The roles the signed-in user may give in the current project, for the role
// pickers on users.
const getAssignableRoles = () => axios.get("api/v1/roles/assignable");

// LF360-2047: `changes` are only the fields that changed, with the version the
// editor opened.
const updateRole = (id, changes) => axios.put(`api/v1/roles/${id}`, changes);

// LF360-2048
const restoreDefaults = (id, version) =>
  axios.post(`api/v1/roles/${id}/restore-defaults`, { version });

// `versions`: role id → the version the screen showed, for every built-in role.
const restoreAllDefaults = (versions) =>
  axios.post("api/v1/roles/restore-defaults", { versions });

// LF360-2046: `role` is name, description, siteScoping, permissions and, if
// the form copied one, the startFrom role id.
const createRole = (role) => axios.post("api/v1/roles", role);

// LF360-2049
const getRoleMembers = (id) => axios.get(`api/v1/roles/${id}/members`);

// `body`: the version the dialog opened, and replacementRoleId when anybody holds it.
const deleteRole = (id, body) => axios.post(`api/v1/roles/${id}/delete`, body);

const ApiRoles = {
  getRoles,
  getRole,
  getCatalog,
  getAssignableRoles,
  createRole,
  getRoleMembers,
  deleteRole,
  updateRole,
  restoreDefaults,
  restoreAllDefaults,
};

export default ApiRoles;
